import { inject, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { AuthGuard } from '@app/core/auth.guard';
import { SocketsService } from '@fui/fui-sockets';
import { MapPageComponent } from './components/map-page/map-page.component';

/**
 * Ангуляр-модуль модуля Карты 2.0
 * Нужен только для инициализации. Просьба делать компоненты standalone.
 */
@NgModule({
    imports: [MapPageComponent],
    providers: [],
})
export class MapModule {
    private readonly socketsService = inject(SocketsService);

    constructor() {
        // Добавляемся в очередь инициализации
        this.socketsService.addInitializer(() => this.init());
    }

    init() {
        const router = inject(Router);

        // Добавляем свои роуты
        const routerConfig = router.config;
        routerConfig.unshift({
            path: 'map',
            canActivate: [AuthGuard],
            component: MapPageComponent,
            data: {
                permissions: 'map',
                is_public: false,
            },
        });
        router.resetConfig(routerConfig);
    }
}
